export default function MySQL_CERTIFICATE() {
  return (
    <div>
      <h2>MySQL_CERTIFICATE</h2>    </div>
  );
}